module.exports = __webpack_public_path__ + "img/mori.cd30e1a1.png";